<ds-loading *ngIf="loader === true"></ds-loading>
<div class="flex flex-col flex-auto md:w-160 md:min-w-160 -m-6">
    <ng-container *ngIf="(note$ | async) as note">
        <div class="m-4">
          
            <div class="flex w-full py-3 pb-0 px-2">
                <textarea
                    class="rounded-lg p-2 cdk-textarea-autosize mat-autosize w-full border-2 h-20	"
                    [placeholder]="'Note'"
                    [(ngModel)]="note.content"
                    matTextareaAutosize></textarea>
            </div>
            <ng-container>
                <div class="flex items-center justify-end mt-4">
                    <button *ngIf="!dialogData.edit_in"
                        mat-flat-button
                        [color]="'primary'"
                        [disabled]="!note.title && !note.content"
                        (click)="createNote(note)">
                        Save
                    </button>
                    <button *ngIf="dialogData.edit_in"
                    mat-flat-button
                    [color]="'primary'"
                    [disabled]="!note.title && !note.content"
                    (click)="updateNote(note)">
                    Update
                </button>
                </div>
            </ng-container>
        </div>
    </ng-container>

</div>
